/**
 * ローディングスクリーン
 *
 * @graph-stack quality-atelier
 * @graph-domain Quality
 * @graph-business 全画面ローディング表示。認証確認中やルート遷移時のスピナー画面
 * @graph-connects none
 */

export function LoadingScreen() {
  return (
    <div
      className="fixed inset-0 flex items-center justify-center"
      style={{ background: 'var(--color-bg-base)' }}
    >
      <div className="flex flex-col items-center gap-4">
        <div className="loading-spinner loading-spinner-lg" />
        <p className="text-sm" style={{ color: 'var(--color-text-muted)' }}>
          読み込み中...
        </p>
      </div>
    </div>
  );
}
